import React, { useState } from 'react';
import { useParams, Link } from 'react-router';
import { motion, AnimatePresence } from 'framer-motion';
import AnimacionPagina from '../componentes/AnimacionPagina';
import productosPersianas from '../data/todosLosProductos/productosPersianas';
import styled from 'styled-components';
import Header from '../componentes/Header';
import WhatsAppShareButton from '../componentes/WhatsAppShareButton';
import BtnVolverAnim from '../elementos/BtnVolverAnim';
import Footer from '../componentes/Footer';

import {FichaProducto, Galeria, MotionImagen, Flecha, Miniaturas, Miniatura} from '../elementos/GaleriaStyles'

const DetallePersiana = () => {
  const { categoriaSlug, slug } = useParams();

  const producto = productosPersianas.find(
     p =>  p.categoriaSlug === categoriaSlug && p.slug === slug
  );


  const [indiceSeleccionado, setIndiceSeleccionado] = useState(0);
  const [animando, setAnimando] = useState(false);
  

  if (!producto) return <h2>Producto no encontrado</h2>;

  const imagenActual =  producto.images[indiceSeleccionado];
  const imagenDeMuestra = producto.images[0];
  const imagenesDeColores = producto.images.slice(1);

  const cambiarImagen = (index) => {
    if (index >= 0 && index < producto.images.length) {
      setAnimando(true);
      setTimeout(() => {
        setIndiceSeleccionado(index);
        setAnimando(false);
      }, 50); 
    }
  };

  return (
    <>
    <Header />
    <AnimacionPagina>
      <FichaProducto>
      <h1>{producto.nombre}</h1>
      <h3>{producto.categoria}</h3>
      <p>Composición: {producto.composicion}</p>
      <p>Largo de rollo: {producto.largoRollo}</p>
      <p>Ancho de rollo: {producto.anchoTela}m</p>
      <p>Peso por M²: {producto.pesoM2}</p>
      <p>Grosor de tela: {producto.grosor}</p>


      <Galeria>
        <Flecha className='flechaBack' onClick={() => cambiarImagen(indiceSeleccionado - 1)}>&larr;</Flecha>
        <AnimatePresence mode="wait">
          <MotionImagen
            key={imagenActual}
            src={imagenActual}
            alt="Imagen seleccionada"
            initial={{ opacity: .5, scale: .5 }}
            animate={{ opacity: 1, scale: 1 }}
            exit={{ opacity: 0, scale: 0 }}
          />
        </AnimatePresence>
        <Flecha className='flechaSig' onClick={() => cambiarImagen(indiceSeleccionado + 1)}>&rarr;</Flecha>
      </Galeria>

 
      <h2>Colores de tela:</h2>
      <Miniaturas> 
        <motion.div
        whileHover={{ scale: 1.1 }}
        whileTap={{ scale: 0.7 }}
        >
          {
            categoriaSlug === 'panel-japones' ?
             <></>
             :
             <Miniatura
             activa={indiceSeleccionado === 0}
             onClick={() => cambiarImagen(0)}
           >
             <img src={imagenDeMuestra} alt="Muestra" />
             <span>Muestra</span>
           </Miniatura>
          }
        
      </motion.div>
        
        {producto.colores.map((color, i) => (
        <motion.div
          whileHover={{ scale: 1.1 }}
          whileTap={{ scale: 0.7 }}
          >
          <Miniatura
            key={color}
            activa={indiceSeleccionado === i + 1}
            onClick={() => cambiarImagen(i + 1)}
          >
            <img src={imagenesDeColores[i]} alt={color} />
            <span>{color}</span>
          </Miniatura>
        </motion.div>
          
        ))}
      </Miniaturas>
      <BtnVolverAnim Ref='/persianas' />
      <WhatsAppShareButton message="¡Mira esta persiana!" />
      </FichaProducto>
      <Footer />
    </AnimacionPagina>
    </>
    
  );
};



export default DetallePersiana;